import BaseDropdown from "@/components/dropdowns/BaseDropdown";
import { cn } from "@/lib/utils";
import { useState } from "react";

import { NavItem } from "../NavBarDesktop";
import { ExternalNavItem } from "../NavBarDesktop";
import { NavLinkDesktop } from "./NavLinkDesktop";

interface NavDropdownProps {
  navDropdownItems: (NavItem | ExternalNavItem)[];
  currentRoute: string;
}

const ExternalNavItemComponent = ({ item }: { item: ExternalNavItem }) => {
  return (
    <a
      href={item.to}
      target="_blank"
      rel="noreferrer"
      className="text-sm font-medium px-2 py-2 flex items-center justify-start gap-x-2 select-none text-dark-tertiary hover:bg-panel-foreground hover:text-white"
    >
      {item.imgUrl && (
        <img src={item.imgUrl} alt={item.label} className="w-5 h-5" />
      )}
      <span>{item.label}</span>
    </a>
  );
};
export const NavDropdown = ({
  navDropdownItems,
  currentRoute,
}: NavDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={cn(
        "text-sm font-medium",
        open ? "text-white" : "text-dark-tertiary hover:text-white/80",
      )}
    >
      <BaseDropdown label={"More"} open={open} setOpen={setOpen}>
        <article className="flex flex-col z-30">
          <div onClick={() => setOpen(false)}>
            {navDropdownItems.map((item) => {
              if ("externalLink" in item) {
                return (
                  <ExternalNavItemComponent item={item} key={item.label} />
                );
              }
              return (
                <NavLinkDesktop
                  to={item.to}
                  currentRoute={currentRoute}
                  isInMoreDropdown
                  key={item.label}
                >
                  {item.label}
                </NavLinkDesktop>
              );
            })}
          </div>
        </article>
      </BaseDropdown>
    </div>
  );
};
